var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagSpain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 45",
    style: {
      enableBackground: "new 0 0 70 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0-spain{fill:#C60B1E;}\r\n\t.st1-spain{fill:#FFC400;}\r\n\t.st2-spain{fill:#AD1519;}\r\n\t.st3-spain{fill:#C8B100;}\r\n\t.st4-spain{fill:none;}\r\n\t.st5-spain{fill:#058E6E;}\r\n\t.st6-spain{fill:#FFFFFF;}\r\n\t.st7-spain{fill:#005BBF;}\r\n\t.st8-spain{fill:#CCCCCC;}\r\n\t.st9-spain{fill:#FFD691;}\r\n\t.st1-spain0{fill:#0039F0;}\r\n\t.st1-spain1{fill:#DB4446;}\r\n\t.st1-spain2{fill:#ED72AA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SpainFlag"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_67",
    y: 0,
    className: "st0-spain",
    width: 70,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_68",
    y: 10.8,
    className: "st1-spain",
    width: 70,
    height: 23.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "coa",
    transform: "translate(14.642 14.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "supporters",
    transform: "translate(0 5.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown_left",
    transform: "translate(0.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    className: "st2-spain",
    d: "M-0.6-0.1C-0.6-0.1-0.6-0.1-0.6-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0l-0.1-0.1 c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0l0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0s0.1,0,0.1,0s0.2,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.2,0.1 c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1L0.9-0.2L0.9-0.2c0,0-0.1,0-0.1,0 c-0.2,0-0.5-0.1-0.7-0.1C-0.2-0.2-0.4-0.2-0.6-0.1L-0.6-0.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    transform: "translate(0.304)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_38",
    className: "st3-spain",
    cx: -0.2,
    cy: -0.7,
    rx: 0.1,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_39",
    className: "st3-spain",
    cx: -0.2,
    cy: -0.7,
    rx: 0.1,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_40",
    className: "st3-spain",
    cx: -0.2,
    cy: -1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    className: "st3-spain",
    d: "M-0.1-1L-0.1-1l-0.2,0.1V-1h0.1v-0.1h-0.1v-0.1h0.1v-0.1h0.1v0.1h0.1v0.1h-0.1L-0.1-1 L-0.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    className: "st4-spain",
    d: "M-0.2-1C-0.2-1-0.1-1-0.2-1c0.1,0.1,0,0.2,0,0.2c0,0-0.1,0-0.1-0.1C-0.3-1-0.3-1-0.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    className: "st3-spain",
    d: "M-0.2-0.2h-0.4l0-0.1l0-0.1l0-0.1C-0.8-0.7-0.9-0.8-1-0.7c0,0,0,0,0-0.1 c0.1-0.1,0.3,0.1,0.5,0.3c0,0,0,0,0,0.1h0.4c0,0,0,0,0-0.1c0.2-0.2,0.4-0.4,0.5-0.3c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.2l0,0.1 l0,0.1l0,0.1H-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    className: "st4-spain",
    d: "M-0.9-0.8c0.1,0,0.3,0.1,0.4,0.3 M0.5-0.8c-0.1,0-0.3,0.1-0.4,0.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "crown_pt1",
    transform: "translate(0 0.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    className: "st3-spain",
    d: "M-0.5-0.6C-0.6-0.7-0.6-0.7-0.5-0.6c0.4-0.2,0.9-0.2,1.3-0.1l0,0.1c0,0,0,0,0,0.1 C0.5-0.6,0.3-0.6,0.1-0.6C-0.1-0.6-0.3-0.6-0.5-0.6C-0.5-0.6-0.5-0.6-0.5-0.6L-0.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    className: "st3-spain",
    d: "M0.1-0.4c0.2,0,0.4,0,0.5-0.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0c-0.4-0.1-0.8-0.1-1.2,0 c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1C-0.3-0.4-0.1-0.4,0.1-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    className: "st3-spain",
    d: "M0.8-0.8L0.8-0.8c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0C0.1-0.9,0.1-1,0.1-1S0-0.9,0-0.9c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1 c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0C-0.1-0.9,0.3-0.9,0.8-0.8L0.8-0.8L0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    className: "st3-spain",
    d: "M0.1-1L0.1-1C0.1-1,0.1-1,0.1-1c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1v0c0,0,0,0,0,0l0,0l0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0.1,0,0.1,0l0,0v0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1v0c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1-0.1c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1 c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1 c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1l0,0c0,0,0,0,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1v0l0,0c0,0,0,0,0.1,0 c0.1,0,0.1,0,0.1-0.1v0c0,0,0,0,0,0l0,0l0,0c0,0,0,0,0,0c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0.1,0.1,0.1,0.1C0-0.9,0-1,0.1-1L0.1-1C0-1,0-1,0.1-1L0.1-1L0.1-1L0.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    className: "st3-spain",
    d: "M0.1-0.8c-0.2,0-0.5,0-0.7,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.5-0.1,0.9-0.1,1.4,0 c0,0,0,0,0,0c0,0,0,0,0,0C0.5-0.8,0.3-0.8,0.1-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    className: "st3-spain",
    d: "M-0.8-0.9C-0.8-0.9-0.9-1-0.8-0.9C-0.9-1-0.9-1-0.9-1c0,0,0,0,0.1,0c0,0,0,0,0,0v0 C-0.8-1-0.8-1-0.8-0.9C-0.8-1-0.8-1-0.8-0.9C-0.8-0.9-0.8-0.9-0.8-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    className: "st3-spain",
    d: "M-0.7-1L-0.7-1l-0.1,0.1l0,0v0L-0.7-1L-0.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    className: "st3-spain",
    d: "M-0.8-0.9C-0.8-0.9-0.8-0.9-0.8-0.9C-0.8-0.9-0.8-0.9-0.8-0.9C-0.8-0.9-0.8-0.9-0.8-0.9 C-0.8-0.9-0.8-0.9-0.8-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    className: "st3-spain",
    d: "M-0.6-0.9C-0.6-0.9-0.6-1-0.6-0.9C-0.6-1-0.6-0.9-0.6-0.9C-0.5-0.9-0.6-0.9-0.6-0.9 C-0.6-0.9-0.6-0.9-0.6-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    className: "st3-spain",
    d: "M-0.5-1L-0.5-1l0.2,0l0,0l0,0L-0.5-1L-0.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    className: "st3-spain",
    d: "M-0.4-1.2L-0.4-1.2l0,0.2l0,0l0,0L-0.4-1.2L-0.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    className: "st3-spain",
    d: "M-0.2-1.1L-0.2-1.1l-0.1,0l0,0l0,0L-0.2-1.1L-0.2-1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_41",
    className: "st3-spain",
    cx: -0.4,
    cy: -1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    className: "st3-spain",
    d: "M-0.2-1C-0.2-1-0.2-1-0.2-1C-0.1-1-0.1-1-0.2-1C-0.1-1-0.1-1-0.2-1C-0.2-1-0.2-1-0.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    className: "st3-spain",
    d: "M-0.1-1.1L-0.1-1.1l0.2,0l0,0l0,0L-0.1-1.1L-0.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    className: "st3-spain",
    d: "M0.1-1.3L0.1-1.3l0,0.2l0,0l0,0L0.1-1.3L0.1-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    className: "st3-spain",
    d: "M0.2-1.1L0.2-1.1l-0.2,0l0,0l0,0L0.2-1.1L0.2-1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_42",
    className: "st3-spain",
    cx: 0.1,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    className: "st3-spain",
    d: "M0.3-1C0.3-1,0.3-1,0.3-1C0.3-1,0.3-1,0.3-1C0.3-1,0.3-1,0.3-1C0.3-1,0.3-1,0.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    className: "st3-spain",
    d: "M0.4-1.1L0.4-1.1l0.1,0l0,0l0,0L0.4-1.1L0.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    className: "st3-spain",
    d: "M0.6-1.2L0.6-1.2l0,0.2l0,0l0,0L0.6-1.2L0.6-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    className: "st3-spain",
    d: "M0.7-1L0.7-1L0.5-1l0,0l0,0L0.7-1L0.7-1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_43",
    className: "st3-spain",
    cx: 0.5,
    cy: -1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    className: "st3-spain",
    d: "M0.8-0.9C0.8-0.9,0.8-1,0.8-0.9C0.7-1,0.7-0.9,0.8-0.9C0.7-0.9,0.7-0.9,0.8-0.9 C0.7-0.9,0.7-0.9,0.8-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    className: "st3-spain",
    d: "M1-0.9C1-0.9,1-1,1-0.9C1-1,1.1-1,1.1-1c0,0,0,0-0.1,0c0,0,0,0,0,0v0C1-1,1-1,1-0.9 C1-1,1-1,1-0.9C1-0.9,1-0.9,1-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    className: "st3-spain",
    d: "M0.8-1L0.8-1l0.1,0.1l0,0v0L0.8-1L0.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    className: "st3-spain",
    d: "M1-0.9C1-0.9,0.9-0.9,1-0.9C0.9-0.9,0.9-0.9,1-0.9C0.9-0.9,0.9-0.9,1-0.9 C1-0.9,1-0.9,1-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "crown_pt2",
    transform: "translate(0.371 1.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    className: "st2-spain",
    d: "M-1-1.2L-1-1.2L-1-1.2L-1-1.2L-1-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    className: "st5-spain",
    d: "M-0.7-1.2L-0.7-1.2C-0.8-1.2-0.8-1.2-0.7-1.2C-0.8-1.2-0.8-1.3-0.7-1.2L-0.7-1.2 L-0.7-1.2C-0.7-1.3-0.6-1.3-0.7-1.2C-0.6-1.2-0.6-1.2-0.7-1.2L-0.7-1.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_44",
    className: "st6-spain",
    cx: -0.5,
    cy: -1.3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    className: "st2-spain",
    d: "M-0.3-1.2L-0.3-1.2c-0.1,0-0.1,0-0.1,0C-0.4-1.3-0.4-1.3-0.3-1.2L-0.3-1.2 c0.1-0.1,0.1,0,0.1,0c0,0,0,0,0,0C-0.2-1.3-0.2-1.2-0.3-1.2L-0.3-1.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_45",
    className: "st6-spain",
    cx: -0.1,
    cy: -1.3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    className: "st5-spain",
    d: "M0.1-1.2L0.1-1.2C0.2-1.2,0.2-1.2,0.1-1.2C0.2-1.2,0.2-1.3,0.1-1.2L0.1-1.2L0.1-1.2 C0.1-1.3,0-1.3,0.1-1.2L0.1-1.2C0-1.2,0.1-1.2,0.1-1.2C0.1-1.2,0.1-1.2,0.1-1.2L0.1-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    className: "st2-spain",
    d: "M0.4-1.2L0.4-1.2L0.4-1.2L0.4-1.2L0.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    className: "st2-spain",
    d: "M-0.3-1c-0.2,0-0.4,0-0.6-0.1c0.4-0.1,0.7-0.1,1.1,0C0.1-1-0.1-1-0.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    className: "st4-spain",
    d: "M-0.2-1v-0.1 M-0.2-1v-0.1 M-0.3-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    className: "st4-spain",
    d: "M-0.3-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    className: "st4-spain",
    d: "M-0.3-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    className: "st4-spain",
    d: "M-0.4-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    className: "st4-spain",
    d: "M-0.4-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    className: "st4-spain",
    d: "M-0.4-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    className: "st4-spain",
    d: "M-0.5-1v-0.1 M-0.5-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    className: "st4-spain",
    d: "M-0.5-1L-0.5-1 M-0.5-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_197",
    className: "st4-spain",
    d: "M-0.6-1L-0.6-1 M-0.6-1L-0.6-1 M-0.5-1L-0.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    className: "st4-spain",
    d: "M-0.6-1L-0.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_199",
    className: "st4-spain",
    d: "M-0.6-1L-0.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    className: "st4-spain",
    d: "M-0.6-1L-0.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    className: "st4-spain",
    d: "M-0.7-1L-0.7-1 M-0.7-1L-0.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_202",
    className: "st4-spain",
    d: "M-0.7-1L-0.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_203",
    className: "st4-spain",
    d: "M-0.7-1L-0.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_204",
    className: "st4-spain",
    d: "M-0.7-1L-0.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_205",
    className: "st4-spain",
    d: "M-0.8-1L-0.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_206",
    className: "st4-spain",
    d: "M-0.8-1L-0.8-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pillar_left",
    transform: "translate(0.398 1.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    transform: "translate(0 9.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    className: "st7-spain",
    d: "M1.8-1.8c-0.1,0-0.2,0-0.3-0.1C1.4-1.9,1.3-1.9,1.1-1.9c-0.1,0-0.2,0-0.3,0.1 C0.7-1.8,0.6-1.8,0.4-1.8c-0.1,0-0.2,0-0.3-0.1C0-1.9-0.1-1.9-0.2-1.9c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v0.2 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.2,0.1,0.5,0.1,0.7,0C0.9-1.7,1-1.7,1.1-1.7 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1L1.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    className: "st8-spain",
    d: "M1.8-1.5c-0.1,0-0.2,0-0.3-0.1C1.3-1.7,1-1.7,0.8-1.6c-0.2,0.1-0.5,0.1-0.7,0 C0-1.7-0.1-1.7-0.2-1.7c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v0.2c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1C0.9-1.5,1-1.5,1.1-1.5c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.2,0.1,0.3,0.1L1.8-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    className: "st7-spain",
    d: "M1.8-1.3c-0.1,0-0.2,0-0.3-0.1C1.4-1.5,1.3-1.5,1.1-1.5c-0.1,0-0.2,0-0.3,0.1 C0.7-1.4,0.6-1.3,0.4-1.3c-0.1,0-0.2,0-0.3-0.1C0-1.5-0.1-1.5-0.2-1.5c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v0.2 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1 C0.9-1.2,1-1.3,1.1-1.3c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1L1.8-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    className: "st8-spain",
    d: "M1.8-0.9c-0.1,0-0.2,0-0.3-0.1C1.3-1.1,1-1.1,0.8-1C0.7-0.9,0.6-0.9,0.4-0.9 c-0.1,0-0.2,0-0.3-0.1C0-1-0.1-1.1-0.2-1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v-0.2c0.1,0,0.2,0,0.3-0.1 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.5-0.1,0.7,0 c0.1,0.1,0.2,0.1,0.3,0.1L1.8-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    className: "st7-spain",
    d: "M1.8-0.7c-0.1,0-0.2,0-0.3-0.1C1.4-0.8,1.3-0.8,1.1-0.8c-0.1,0-0.2,0-0.3,0.1 C0.7-0.7,0.6-0.7,0.4-0.7c-0.1,0-0.2,0-0.3-0.1C0-0.8-0.1-0.8-0.2-0.8c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v-0.2 c0.1,0,0.2,0,0.3-0.1C-0.5-1-0.3-1.1-0.2-1C-0.1-1,0-1,0.1-1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1C0.9-1,1-1.1,1.1-1 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1L1.8-0.7L1.8-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    transform: "translate(0.386 8.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    className: "st3-spain",
    d: "M-0.7-1.7c0,0.1,0,0.2-0.1,0.3c0,0-0.1,0-0.1,0h2C1-1.4,0.8-1.5,0.8-1.6c0,0,0-0.1,0-0.1 c0,0,0,0,0,0L-0.7-1.7C-0.7-1.7-0.7-1.7-0.7-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    className: "st3-spain",
    d: "M-0.7-1.9h1.5c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-1.5 C-0.7-1.7-0.8-1.7-0.7-1.9C-0.8-1.8-0.7-1.9-0.7-1.9C-0.7-1.9-0.7-1.9-0.7-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    className: "st3-spain",
    d: "M-0.9-0.9h2v-0.5h-2V-0.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    className: "st8-spain",
    d: "M-0.3,7h1.4v-7.2h-1.4V7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    className: "st4-spain",
    d: "M0.8-0.2V7 M0.9-0.2V7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    transform: "translate(0.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    className: "st3-spain",
    d: "M-0.9-0.8h2v-0.5h-2V-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    className: "st3-spain",
    d: "M-0.7-0.4C-0.7-0.4-0.7-0.4-0.7-0.4l1.5,0c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0,0h-1.5c0,0,0,0,0,0h0c0.1,0,0.1,0.1,0.1,0.1C-0.7-0.5-0.7-0.5-0.7-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    className: "st3-spain",
    d: "M-0.7-0.4h1.5c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-1.5 C-0.7-0.3-0.8-0.3-0.7-0.4C-0.8-0.4-0.8-0.4-0.7-0.4C-0.7-0.4-0.7-0.4-0.7-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    className: "st3-spain",
    d: "M-0.7-0.8h1.5c0.1,0,0.1,0,0.1,0.1s0,0.1-0.1,0.1h-1.5C-0.8-0.7-0.8-0.7-0.7-0.8 C-0.8-0.8-0.8-0.8-0.7-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ribbon_left",
    transform: "translate(0 4.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    className: "st2-spain",
    d: "M-0.3,2.3c-0.2,0.1-0.3,0.2-0.3,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.3,0.2,0.4 C-0.1,3,0,2.6-0.3,2.3C-0.3,2.4-0.3,2.3-0.3,2.3L-0.3,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_222",
    className: "st2-spain",
    d: "M3-0.4C2.3-0.7,1.6-0.7,0.9-0.6C0-0.4-0.6-0.1-0.6,0.2v0c0,0-0.3-0.7-0.3-0.8 C-1-0.9-0.2-1.3,0.7-1.4c0.3,0,0.6-0.1,0.8-0.1c0.5,0,1,0.1,1.5,0.2L3-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_223",
    className: "st2-spain",
    d: "M0.1,0.5c-0.4,0-0.7-0.1-0.7-0.3c0-0.1,0.1-0.3,0.4-0.4c0.1,0,0.2,0,0.4,0L0.1,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_224",
    className: "st2-spain",
    d: "M1.6-0.1C1.8,0,1.9,0,2.1,0.1l0,0c0,0.1-0.2,0.3-0.5,0.5L1.6-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_225",
    className: "st2-spain",
    d: "M-0.8,1.9c0-0.1,0.4-0.3,0.9-0.6C0.4,1.2,0.6,1.1,0.9,1c0.8-0.3,1.3-0.7,1.3-0.9l0,0 c0.1,0.2,0.1,0.5,0.1,0.7C2.3,1,1.8,1.4,1.1,1.7C0.8,1.8,0.4,2,0.1,2.1c-0.4,0.1-0.8,0.4-0.8,0.5L-0.8,1.9L-0.8,1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "crown_right",
    transform: "translate(14.767 0.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_226",
    className: "st2-spain",
    d: "M-0.8-0.4c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1 c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0.1c0,0,0,0,0,0l-0.1,0l-0.1-0.1l-0.1,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1,0,0.2,0C-1.2-0.7-1.1-0.7-1-0.7c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1l-0.1,0L0-0.3L0-0.2c0,0,0,0,0,0 c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0.1-0.1,0 C-0.7-0.3-0.7-0.4-0.8-0.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    transform: "translate(0.969)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_46",
    className: "st3-spain",
    cx: -1.7,
    cy: -0.8,
    rx: 0.1,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_47",
    className: "st3-spain",
    cx: -1.7,
    cy: -0.8,
    rx: 0.1,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_48",
    className: "st3-spain",
    cx: -1.7,
    cy: -1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_227",
    className: "st3-spain",
    d: "M-1.6-1L-1.6-1L-1.8-1V-1h0.1v-0.1h-0.1v-0.1h0.1v-0.1h0.1v0.1h0.1v0.1h-0.1L-1.6-1 L-1.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_228",
    className: "st4-spain",
    d: "M-1.7-1.1C-1.7-1-1.6-1-1.7-1.1c0,0.1,0,0.2,0,0.2c0,0-0.1,0-0.1-0.1 C-1.8-1-1.8-1-1.7-1.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    transform: "translate(0 0.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_229",
    className: "st4-spain",
    d: "M-1.7-0.7C-1.7-0.7-1.7-0.7-1.7-0.7C-1.7-0.9-1.6-1-1.5-1c0,0,0,0,0,0c0,0,0.1,0,0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_230",
    className: "st4-spain",
    d: "M-1.2-0.9C-1.3-0.9-1.3-0.9-1.2-0.9c0-0.2,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_231",
    className: "st4-spain",
    d: "M-0.3-0.9C-0.3-0.9-0.3-0.9-0.3-0.9c0-0.2-0.1-0.3-0.2-0.3c-0.1,0-0.1,0-0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_232",
    className: "st4-spain",
    d: "M0.1-0.7C0.2-0.7,0.2-0.7,0.1-0.7C0.2-0.9,0.1-1-0.1-1c0,0-0.1,0-0.1,0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_49",
    className: "st4-spain",
    cx: -1.8,
    cy: -0.8,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_50",
    className: "st4-spain",
    cx: -1.7,
    cy: -0.9,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_51",
    className: "st4-spain",
    cx: -1.7,
    cy: -1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_52",
    className: "st4-spain",
    cx: -1.5,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_53",
    className: "st4-spain",
    cx: -1.4,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_54",
    className: "st6-spain",
    cx: -1.3,
    cy: -0.9,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_55",
    className: "st4-spain",
    cx: -1.3,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_56",
    className: "st4-spain",
    cx: -1.2,
    cy: -1.2,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_57",
    className: "st4-spain",
    cx: -1.1,
    cy: -1.2,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_58",
    className: "st4-spain",
    cx: -1,
    cy: -1.2,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_59",
    className: "st4-spain",
    cx: -0.6,
    cy: -1.2,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_60",
    className: "st4-spain",
    cx: -0.5,
    cy: -1.2,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_61",
    className: "st4-spain",
    cx: -0.3,
    cy: -1.2,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_62",
    className: "st4-spain",
    cx: -0.2,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_63",
    className: "st6-spain",
    cx: -0.2,
    cy: -0.9,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_64",
    className: "st4-spain",
    cx: -0.1,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_65",
    className: "st4-spain",
    cx: 0,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_66",
    className: "st4-spain",
    cx: 0.1,
    cy: -1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_67",
    className: "st4-spain",
    cx: 0.2,
    cy: -0.9,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_68",
    className: "st4-spain",
    cx: 0.2,
    cy: -0.8,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    transform: "translate(0.014 0.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_233",
    className: "st3-spain",
    d: "M-1.4-0.6C-1.4-0.7-1.4-0.7-1.4-0.6C-1-0.8-0.5-0.8-0.1-0.7l0,0.1c0,0,0,0,0,0.1 c-0.2-0.1-0.4-0.1-0.6-0.1C-1-0.6-1.2-0.6-1.4-0.6C-1.4-0.6-1.4-0.6-1.4-0.6L-1.4-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_234",
    className: "st3-spain",
    d: "M-0.8-0.4c0.2,0,0.4,0,0.5-0.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0c-0.4-0.1-0.8-0.1-1.2,0 c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1C-1.1-0.4-1-0.4-0.8-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_235",
    className: "st3-spain",
    d: "M-0.1-0.8L-0.1-0.8c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0C-0.7-0.9-0.8-1-0.8-1s-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0-0.1-0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0C-1-0.9-0.5-0.9-0.1-0.8L-0.1-0.8 L-0.1-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_236",
    className: "st3-spain",
    d: "M-0.8-1L-0.8-1C-0.8-1-0.8-1-0.8-1c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1v0c0,0,0,0,0,0l0,0l0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0.1,0,0.1,0l0,0v0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1v0C0-0.9,0-0.8,0-0.8c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1-0.1c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1 c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1 c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1l0,0c0,0,0,0,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1v0l0,0c0,0,0,0,0.1,0 c0.1,0,0.1,0,0.1-0.1v0c0,0,0,0,0,0l0,0l0,0c0,0,0,0,0,0c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0.1,0.1,0.1,0.1C-0.9-0.9-0.8-1-0.8-1L-0.8-1C-0.8-1-0.8-1-0.8-1L-0.8-1L-0.8-1L-0.8-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237",
    className: "st3-spain",
    d: "M-0.8-0.8c-0.2,0-0.5,0-0.7,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.5-0.1,0.9-0.1,1.4,0 c0,0,0,0,0,0c0,0,0,0,0,0C-0.3-0.8-0.6-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238",
    className: "st3-spain",
    d: "M-1.7-0.9C-1.7-0.9-1.7-1-1.7-0.9C-1.8-1-1.8-1-1.8-1c0,0,0,0,0.1,0c0,0,0,0,0,0v0 C-1.7-1-1.7-1-1.7-0.9C-1.7-1-1.7-1-1.7-0.9C-1.7-0.9-1.7-0.9-1.7-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_239",
    className: "st3-spain",
    d: "M-1.5-1L-1.5-1l-0.1,0.1l0,0v0L-1.5-1L-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_240",
    className: "st3-spain",
    d: "M-1.7-0.9C-1.7-0.9-1.6-0.9-1.7-0.9C-1.6-0.9-1.6-0.9-1.7-0.9C-1.6-0.9-1.7-0.9-1.7-0.9 C-1.7-0.9-1.7-0.9-1.7-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_241",
    className: "st3-spain",
    d: "M-1.5-0.9C-1.5-0.9-1.5-1-1.5-0.9C-1.4-1-1.4-0.9-1.5-0.9C-1.4-0.9-1.4-0.9-1.5-0.9 C-1.4-0.9-1.4-0.9-1.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_242",
    className: "st3-spain",
    d: "M-1.4-1L-1.4-1l0.2,0l0,0l0,0L-1.4-1L-1.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_243",
    className: "st3-spain",
    d: "M-1.3-1.2L-1.3-1.2l0,0.2l0,0l0,0L-1.3-1.2L-1.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_244",
    className: "st3-spain",
    d: "M-1.1-1.1L-1.1-1.1l-0.1,0l0,0l0,0L-1.1-1.1L-1.1-1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_69",
    className: "st3-spain",
    cx: -1.2,
    cy: -1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_245",
    className: "st3-spain",
    d: "M-1-1C-1-1-1-1-1-1C-1-1-1-1-1-1C-1-1-1-1-1-1C-1-1-1-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_246",
    className: "st3-spain",
    d: "M-0.9-1.1L-0.9-1.1l0.2,0l0,0l0,0L-0.9-1.1L-0.9-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_247",
    className: "st3-spain",
    d: "M-0.8-1.3L-0.8-1.3l0,0.2l0,0l0,0L-0.8-1.3L-0.8-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_248",
    className: "st3-spain",
    d: "M-0.6-1.1L-0.6-1.1l-0.2,0l0,0l0,0L-0.6-1.1L-0.6-1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_70",
    className: "st3-spain",
    cx: -0.8,
    cy: -1.1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_249",
    className: "st3-spain",
    d: "M-0.5-1C-0.5-1-0.5-1-0.5-1C-0.6-1-0.6-1-0.5-1C-0.6-1-0.6-1-0.5-1C-0.5-1-0.5-1-0.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_250",
    className: "st3-spain",
    d: "M-0.5-1.1L-0.5-1.1l0.1,0l0,0l0,0L-0.5-1.1L-0.5-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_251",
    className: "st3-spain",
    d: "M-0.3-1.2L-0.3-1.2l0,0.2l0,0l0,0L-0.3-1.2L-0.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_252",
    className: "st3-spain",
    d: "M-0.2-1L-0.2-1l-0.2,0l0,0l0,0L-0.2-1L-0.2-1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_71",
    className: "st3-spain",
    cx: -0.3,
    cy: -1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_253",
    className: "st3-spain",
    d: "M-0.1-0.9C-0.1-0.9-0.1-1-0.1-0.9C-0.1-1-0.1-0.9-0.1-0.9C-0.2-0.9-0.1-0.9-0.1-0.9 C-0.1-0.9-0.1-0.9-0.1-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_254",
    className: "st3-spain",
    d: "M0.1-0.9C0.1-0.9,0.1-1,0.1-0.9C0.2-1,0.2-1,0.2-1c0,0,0,0-0.1,0c0,0,0,0,0,0v0 C0.1-1,0.1-1,0.1-0.9C0.1-1,0.1-1,0.1-0.9C0.1-0.9,0.1-0.9,0.1-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_255",
    className: "st3-spain",
    d: "M-0.1-1L-0.1-1l0.1,0.1l0,0v0L-0.1-1L-0.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_256",
    className: "st3-spain",
    d: "M0.1-0.9C0.1-0.9,0.1-0.9,0.1-0.9C0-0.9,0-0.9,0.1-0.9C0.1-0.9,0.1-0.9,0.1-0.9 C0.1-0.9,0.1-0.9,0.1-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    transform: "translate(0.385 1.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_257",
    className: "st2-spain",
    d: "M-1.8-1.2L-1.8-1.2L-1.8-1.2L-1.8-1.2L-1.8-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_258",
    className: "st5-spain",
    d: "M-1.6-1.2L-1.6-1.2C-1.7-1.2-1.7-1.2-1.6-1.2C-1.7-1.2-1.7-1.3-1.6-1.2L-1.6-1.2 L-1.6-1.2C-1.5-1.3-1.5-1.3-1.6-1.2C-1.5-1.2-1.5-1.2-1.6-1.2L-1.6-1.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_72",
    className: "st6-spain",
    cx: -1.4,
    cy: -1.3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_259",
    className: "st2-spain",
    d: "M-1.1-1.2L-1.1-1.2c-0.1,0-0.1,0-0.1,0C-1.3-1.3-1.3-1.3-1.1-1.2L-1.1-1.2 C-1-1.3-1-1.3-1-1.3c0,0,0,0,0,0C-1-1.3-1-1.2-1.1-1.2L-1.1-1.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_73",
    className: "st6-spain",
    cx: -0.9,
    cy: -1.3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_260",
    className: "st5-spain",
    d: "M-0.7-1.2L-0.7-1.2C-0.6-1.2-0.6-1.2-0.7-1.2C-0.6-1.2-0.6-1.3-0.7-1.2L-0.7-1.2 L-0.7-1.2C-0.8-1.3-0.8-1.3-0.7-1.2L-0.7-1.2C-0.8-1.2-0.8-1.2-0.7-1.2C-0.8-1.2-0.8-1.2-0.7-1.2L-0.7-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_261",
    className: "st2-spain",
    d: "M-0.5-1.2L-0.5-1.2L-0.5-1.2L-0.5-1.2L-0.5-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_262",
    className: "st2-spain",
    d: "M-1.2-1c-0.2,0-0.4,0-0.6-0.1c0.4-0.1,0.7-0.1,1.1,0C-0.8-1-1-1-1.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_263",
    className: "st4-spain",
    d: "M-1.1-1v-0.1 M-1.1-1v-0.1 M-1.1-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_264",
    className: "st4-spain",
    d: "M-1.2-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_265",
    className: "st4-spain",
    d: "M-1.2-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_266",
    className: "st4-spain",
    d: "M-1.2-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_267",
    className: "st4-spain",
    d: "M-1.3-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_268",
    className: "st4-spain",
    d: "M-1.3-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_269",
    className: "st4-spain",
    d: "M-1.3-1v-0.1 M-1.3-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_270",
    className: "st4-spain",
    d: "M-1.4-1L-1.4-1 M-1.4-1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_271",
    className: "st4-spain",
    d: "M-1.4-1L-1.4-1 M-1.4-1L-1.4-1 M-1.4-1L-1.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_272",
    className: "st4-spain",
    d: "M-1.5-1L-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_273",
    className: "st4-spain",
    d: "M-1.5-1L-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_274",
    className: "st4-spain",
    d: "M-1.5-1L-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_275",
    className: "st4-spain",
    d: "M-1.5-1L-1.5-1 M-1.5-1L-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_276",
    className: "st4-spain",
    d: "M-1.6-1L-1.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_277",
    className: "st4-spain",
    d: "M-1.6-1L-1.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_278",
    className: "st4-spain",
    d: "M-1.6-1L-1.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_279",
    className: "st4-spain",
    d: "M-1.6-1L-1.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_280",
    className: "st4-spain",
    d: "M-1.7-1L-1.7-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pillar_right",
    transform: "translate(14.408 1.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    transform: "translate(0 9.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_281",
    className: "st7-spain",
    d: "M1-1.8c-0.1,0-0.2,0-0.3-0.1C0.5-1.9,0.4-1.9,0.3-1.9c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v0.2 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.2,0.1,0.5,0.1,0.7,0C0-1.7,0.2-1.7,0.3-1.7 c0.1,0,0.2,0,0.3,0.1C0.7-1.6,0.8-1.5,1-1.6L1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_282",
    className: "st8-spain",
    d: "M1-1.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.5-0.1-0.7,0c-0.2,0.1-0.5,0.1-0.7,0 c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v0.2c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1C0-1.5,0.2-1.5,0.3-1.5c0.1,0,0.2,0,0.3,0.1 C0.7-1.4,0.8-1.3,1-1.3L1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_283",
    className: "st7-spain",
    d: "M1-1.3c-0.1,0-0.2,0-0.3-0.1C0.5-1.5,0.4-1.5,0.3-1.5c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v0.2 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1 C0-1.2,0.2-1.3,0.3-1.3c0.1,0,0.2,0,0.3,0.1C0.7-1.1,0.8-1.1,1-1.1L1-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_284",
    className: "st8-spain",
    d: "M1-0.9c-0.1,0-0.2,0-0.3-0.1C0.4-1.1,0.2-1.1-0.1-1c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.1,0-0.2,0-0.3-0.1C-0.9-1-1-1.1-1.1-1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v-0.2c0.1,0,0.2,0,0.3-0.1 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.5-0.1,0.7,0 C0.7-1.1,0.8-1.1,1-1.1L1-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_285",
    className: "st7-spain",
    d: "M1-0.7c-0.1,0-0.2,0-0.3-0.1C0.5-0.8,0.4-0.8,0.3-0.8c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1v-0.2 c0.1,0,0.2,0,0.3-0.1C-1.3-1-1.2-1.1-1.1-1C-1-1-0.9-1-0.8-1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1C0-1,0.2-1.1,0.3-1 c0.1,0,0.2,0,0.3,0.1C0.7-0.9,0.8-0.9,1-0.9L1-0.7L1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    transform: "translate(0.386 8.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_286",
    className: "st3-spain",
    d: "M-1.6-1.7c0,0.1,0,0.2-0.1,0.3c0,0-0.1,0-0.1,0h2C0.1-1.4,0-1.5,0-1.6c0,0,0-0.1,0-0.1 c0,0,0,0,0,0L-1.6-1.7C-1.5-1.7-1.6-1.7-1.6-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_287",
    className: "st3-spain",
    d: "M-1.5-1.9h1.5c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-1.5 C-1.6-1.7-1.6-1.7-1.5-1.9C-1.6-1.8-1.6-1.9-1.5-1.9C-1.6-1.9-1.5-1.9-1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_288",
    className: "st3-spain",
    d: "M-1.8-0.9h2v-0.5h-2V-0.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_289",
    className: "st8-spain",
    d: "M-1.1,7h1.4v-7.2h-1.4V7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_290",
    className: "st4-spain",
    d: "M-0.1-0.2V7 M0.1-0.2V7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    transform: "translate(0.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_291",
    className: "st3-spain",
    d: "M-1.8-0.8h2v-0.5h-2V-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_292",
    className: "st3-spain",
    d: "M-1.6-0.4C-1.6-0.4-1.6-0.4-1.6-0.4l1.5,0c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0,0h-1.5c0,0,0,0,0,0h0c0.1,0,0.1,0.1,0.1,0.1C-1.5-0.5-1.5-0.5-1.6-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_293",
    className: "st3-spain",
    d: "M-1.6-0.4h1.5c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-1.5 C-1.6-0.3-1.6-0.3-1.6-0.4C-1.7-0.4-1.6-0.4-1.6-0.4C-1.6-0.4-1.6-0.4-1.6-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_294",
    className: "st3-spain",
    d: "M-1.6-0.8h1.5C0-0.8,0-0.8,0-0.7s0,0.1-0.1,0.1h-1.5C-1.6-0.7-1.7-0.7-1.6-0.8 C-1.7-0.8-1.6-0.8-1.6-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ribbon_right",
    transform: "translate(17.73 9.358) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295",
    className: "st2-spain",
    d: "M2.6,2.6C2.4,2.5,2.2,2.4,2.2,2.3c0-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.3,0.2-0.4 C2.7,1.9,2.8,2,2.8,2.2C2.8,2.4,2.7,2.5,2.6,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    className: "st2-spain",
    d: "M5.9,5.3c-0.5,0.2-1,0.2-1.5,0.3c-0.2,0-0.5,0-0.7-0.1C2.9,5.4,2.3,5,2.3,4.7l0,0 c0,0-0.3,0.7-0.3,0.8C1.9,5.8,2.6,6.2,3.6,6.4c0.3,0,0.6,0.1,0.8,0.1c0.5,0,1-0.1,1.5-0.2L5.9,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297",
    className: "st2-spain",
    d: "M3,4.4c-0.4,0-0.7,0.1-0.7,0.3c0,0.1,0.1,0.3,0.4,0.4c0.1,0,0.2,0,0.4,0L3,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298",
    className: "st2-spain",
    d: "M4.4,5C4.6,5,4.8,4.9,5,4.8l0,0c0-0.1-0.2-0.3-0.5-0.5V5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    className: "st2-spain",
    d: "M2.1,3c0,0.1,0.4,0.3,0.9,0.6c0.3,0.1,0.5,0.2,0.7,0.3C4.5,4.2,5,4.6,5,4.8l0,0 C5,4.6,5.1,4.3,5.1,4.1c0.1-0.1-0.4-0.5-1.1-0.9C3.7,3.1,3.2,2.9,3,2.8C2.6,2.7,2.2,2.4,2.2,2.3L2.1,3L2.1,3L2.1,3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plus_ultra",
    transform: "translate(0.705 4.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    className: "st3-spain",
    d: "M-0.7-0.9C-0.5-1-0.4-1-0.4-1.2c0-0.1-0.1-0.1-0.3-0.1l-0.2,0.1l0.2,0.5c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0L-0.7-0.9L-0.7-0.9z M-0.8-1.2L-0.8-1.2c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0,0,0-0.1,0 L-0.8-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_301",
    className: "st3-spain",
    d: "M-0.1-1.4C-0.1-1.4-0.2-1.4-0.1-1.4l-0.2,0l0.1,0.6l0.4-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0.1L-0.1-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302",
    className: "st3-spain",
    d: "M0.7-0.9c0.1-0.2,0.2-0.4,0.2-0.6c0,0,0,0,0,0h0c0,0.1-0.1,0.3-0.2,0.4 C0.6-1.2,0.5-1.3,0.4-1.5l-0.1,0c0,0-0.1,0-0.1,0C0.4-1.3,0.5-1.1,0.7-0.9L0.7-0.9C0.6-0.9,0.6-0.9,0.7-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_303",
    className: "st3-spain",
    d: "M1.5-1.3C1.5-1.4,1.5-1.4,1.5-1.3c0-0.1-0.1-0.1-0.1-0.1c-0.2,0-0.2,0.1-0.3,0.2 c0,0.2,0.3,0.2,0.3,0.3c0,0.1-0.1,0.1-0.1,0.1C1.2-0.9,1.1-1,1.1-1h0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.2,0.1c0.2,0,0.3,0,0.3-0.2 c0-0.2-0.3-0.2-0.3-0.3c0,0,0-0.1,0.1-0.1C1.4-1.4,1.4-1.4,1.5-1.3L1.5-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_304",
    className: "st3-spain",
    d: "M12-0.9c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0,0,0,0c0,0,0,0,0,0C12.1-1.3,12-1.2,12-1 c-0.1-0.1-0.2-0.3-0.2-0.4c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0C11.7-1.2,11.8-1,12-0.9C11.9-0.9,12-0.9,12-0.9L12-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_305",
    className: "st3-spain",
    d: "M12.6-1.5C12.5-1.5,12.5-1.5,12.6-1.5c-0.1,0-0.1,0-0.2,0l0,0.6l0.4,0c0,0,0,0,0,0 c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0L12.6-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_306",
    className: "st3-spain",
    d: "M13.2-1.4c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0l-0.5,0c0,0,0,0,0,0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0l0,0.5c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0L13.2-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    className: "st3-spain",
    d: "M13.4-0.8L13.4-0.8c0.1,0,0.1,0,0.2,0L13.6-1h0c0,0,0,0.1,0,0.1l0.1,0.2c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0l0-0.1c0-0.1-0.1-0.2-0.1-0.3c0.1,0,0.2,0,0.2-0.1c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2-0.1l-0.2,0L13.4-0.8  M13.7-1.3c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0.1-0.1,0.1-0.2,0.1L13.7-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    className: "st3-spain",
    d: "M14.4-0.6c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0L14.6-1l0,0c0,0,0,0,0,0 L14-0.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0.2-0.1L14.4-0.6L14.4-0.6z M14.3-0.8l0.2-0.1l0,0.2L14.3-0.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crown_crest",
    transform: "translate(3.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309",
    className: "st2-spain",
    d: "M3.7,1.6c0.5,0,1,0.1,1.4,0.2C5.4,1.9,5.6,1.9,5.9,2c0.2,0,0.4,0,0.6,0 c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.4L8,2.8l0,0.4L7.5,3.6L7.4,3.8L6.9,4.1l-0.2,0L6.6,4.3L3.7,4L0.8,4.3L0.7,4.1 l-0.2,0L0,3.8l-0.2-0.2l-0.4-0.4l0-0.4l-0.1-0.1C-0.5,2.5-0.3,2.3,0,2.2C0.3,2.1,0.6,2,0.9,2c0.2,0,0.4,0,0.6,0 c0.3,0,0.5-0.1,0.7-0.2C2.7,1.6,3.2,1.5,3.7,1.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    transform: "translate(0.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_310",
    className: "st3-spain",
    d: "M1.3,2.3l0.1,0.1l0.2-0.3C1.4,2,1.2,1.8,1.2,1.5c0,0,0-0.1,0-0.1c0-0.4,0.5-0.7,1.1-0.7 c0.3,0,0.5,0.1,0.8,0.2c0-0.1,0-0.1,0-0.2C2.9,0.7,2.6,0.6,2.3,0.6C1.7,0.5,1.2,0.9,1.1,1.5c0,0,0,0.1,0,0.1 c0,0.2,0.1,0.5,0.3,0.6L1.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_311",
    className: "st3-spain",
    d: "M1.3,2.3C1,2.2,0.9,1.9,0.9,1.7c0-0.3,0.2-0.6,0.5-0.8C1.2,1,1.1,1.2,1.1,1.5 c0,0,0,0.1,0,0.1c0,0.2,0.1,0.5,0.3,0.6L1.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_312",
    className: "st3-spain",
    d: "M-0.8,2.6C-1,2.4-1.1,2-0.9,1.7C-0.6,1.3,0,1,0.6,1.1c0.2,0,0.4,0,0.5,0.1 c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.3,0-0.4,0C0,1.2-0.5,1.4-0.8,1.8c0,0.1-0.1,0.2-0.1,0.3c0,0.2,0.1,0.4,0.2,0.5L-0.8,3l-0.1-0.1 L-0.8,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_313",
    className: "st3-spain",
    d: "M-0.5,1.3c-0.2,0.1-0.3,0.2-0.4,0.4C-1.1,2-1,2.4-0.8,2.6l-0.1,0.2 c-0.1-0.2-0.2-0.4-0.2-0.6C-1.1,1.9-0.9,1.5-0.5,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_314",
    className: "st3-spain",
    d: "M3.4,0.5c0.2,0,0.3,0.1,0.3,0.2c0,0.1,0,0.3,0,0.4c0,0,0,0,0,0c0,0,0,0,0,0.1 c0,0.3,0,0.5,0.1,0.8L3.4,2.5L3,2.1C3,1.8,3.1,1.5,3.1,1.3c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.3,0-0.4 C3.1,0.6,3.3,0.5,3.4,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_315",
    className: "st3-spain",
    d: "M3.4,0.7c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.3,0,0.4c0,0,0,0,0,0s0,0,0,0.1 c0,0.2,0,0.5,0.1,0.7L3.4,2.3L3.1,2c0.1-0.2,0.1-0.5,0.1-0.7c0,0,0,0,0-0.1s0,0,0,0c0-0.1,0-0.3,0-0.4C3.3,0.7,3.4,0.7,3.4,0.7z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_316",
    className: "st3-spain",
    d: "M5.6,2.3L5.5,2.4L5.3,2.1C5.5,2,5.6,1.8,5.6,1.5c0,0,0-0.1,0-0.1c0-0.4-0.5-0.7-1.1-0.7 C4.3,0.7,4,0.8,3.8,1c0-0.1,0-0.1,0-0.2C4,0.7,4.3,0.6,4.5,0.6c0.6-0.1,1.1,0.3,1.2,0.9c0,0,0,0.1,0,0.1c0,0.2-0.1,0.5-0.3,0.6 L5.6,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_317",
    className: "st3-spain",
    d: "M5.6,2.3C5.8,2.2,6,1.9,6,1.7C6,1.3,5.8,1,5.5,0.9C5.7,1,5.8,1.2,5.8,1.5c0,0,0,0.1,0,0.1 c0,0.2-0.1,0.5-0.3,0.6L5.6,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_318",
    className: "st3-spain",
    d: "M7.6,2.6C7.9,2.4,7.9,2,7.8,1.7C7.4,1.3,6.9,1,6.3,1.1c-0.2,0-0.4,0-0.5,0.1 c0,0,0.1,0.1,0.1,0.1c0.1,0,0.3,0,0.4,0c0.5-0.1,1,0.2,1.3,0.6c0,0.1,0.1,0.2,0.1,0.3c0,0.2-0.1,0.4-0.2,0.5L7.7,3l0.1-0.1 L7.6,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_319",
    className: "st3-spain",
    d: "M7.4,1.3c0.2,0.1,0.3,0.2,0.4,0.4C7.9,2,7.9,2.4,7.6,2.6l0.1,0.2C7.9,2.7,8,2.5,8,2.3 C8,1.9,7.8,1.5,7.4,1.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_74",
    className: "st7-spain",
    cx: 3.4,
    cy: 0.2,
    rx: 0.4,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_320",
    className: "st3-spain",
    d: "M3.3-0.9v0.2H3.1v0.2h0.2v0.6H3.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.1l0,0h0.7l0,0 c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1H3.5v-0.6h0.2v-0.2H3.5v-0.2H3.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    transform: "translate(0 1.31)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_75",
    className: "st6-spain",
    cx: 3.7,
    cy: 0.8,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_76",
    className: "st6-spain",
    cx: 3.7,
    cy: 0.5,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_77",
    className: "st6-spain",
    cx: 3.7,
    cy: 0.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_78",
    className: "st6-spain",
    cx: 3.7,
    cy: -0.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_79",
    className: "st6-spain",
    cx: 3.7,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_80",
    className: "st6-spain",
    cx: -0.8,
    cy: 1.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_81",
    className: "st6-spain",
    cx: -0.9,
    cy: 1.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_82",
    className: "st6-spain",
    cx: -1,
    cy: 1.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_83",
    className: "st6-spain",
    cx: -1,
    cy: 0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_84",
    className: "st6-spain",
    cx: -1,
    cy: 0.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_85",
    className: "st6-spain",
    cx: -0.8,
    cy: 0.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_86",
    className: "st6-spain",
    cx: -0.6,
    cy: 0.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_87",
    className: "st6-spain",
    cx: -0.4,
    cy: -0.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_88",
    className: "st6-spain",
    cx: -0.1,
    cy: -0.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_89",
    className: "st6-spain",
    cx: 0.2,
    cy: -0.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_90",
    className: "st6-spain",
    cx: 0.5,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_91",
    className: "st6-spain",
    cx: 0.8,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_92",
    className: "st6-spain",
    cx: 1.1,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_93",
    className: "st6-spain",
    cx: 1.4,
    cy: 0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_94",
    className: "st6-spain",
    cx: 1.3,
    cy: 0.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_95",
    className: "st6-spain",
    cx: 1.2,
    cy: 0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_96",
    className: "st6-spain",
    cx: 1.2,
    cy: 0.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_97",
    className: "st6-spain",
    cx: 1.3,
    cy: -0.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_98",
    className: "st6-spain",
    cx: 1.4,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_99",
    className: "st6-spain",
    cx: 1.6,
    cy: -0.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_100",
    className: "st6-spain",
    cx: 1.9,
    cy: -0.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_101",
    className: "st6-spain",
    cx: 2.2,
    cy: -0.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_102",
    className: "st6-spain",
    cx: 2.5,
    cy: -0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_103",
    className: "st6-spain",
    cx: 2.8,
    cy: -0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_104",
    className: "st6-spain",
    cx: 3.1,
    cy: -0.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_105",
    className: "st6-spain",
    cx: 3.4,
    cy: -0.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_106",
    className: "st6-spain",
    cx: 4,
    cy: -0.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_107",
    className: "st6-spain",
    cx: 4.3,
    cy: -0.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_108",
    className: "st6-spain",
    cx: 4.6,
    cy: -0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_109",
    className: "st6-spain",
    cx: 4.9,
    cy: -0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_110",
    className: "st6-spain",
    cx: 5.2,
    cy: -0.8,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_111",
    className: "st6-spain",
    cx: 5.5,
    cy: -0.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_112",
    className: "st6-spain",
    cx: 5.8,
    cy: -0.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_113",
    className: "st6-spain",
    cx: 6,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_114",
    className: "st6-spain",
    cx: 6.2,
    cy: -0.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_115",
    className: "st6-spain",
    cx: 6.2,
    cy: 0.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_116",
    className: "st6-spain",
    cx: 6.2,
    cy: 0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_117",
    className: "st6-spain",
    cx: 6.1,
    cy: 0.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_118",
    className: "st6-spain",
    cx: 6,
    cy: 0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_119",
    className: "st6-spain",
    cx: 6.3,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_120",
    className: "st6-spain",
    cx: 6.6,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_121",
    className: "st6-spain",
    cx: 6.9,
    cy: -0.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_122",
    className: "st6-spain",
    cx: 7.2,
    cy: -0.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_123",
    className: "st6-spain",
    cx: 7.5,
    cy: -0.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_124",
    className: "st6-spain",
    cx: 7.8,
    cy: -0.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_125",
    className: "st6-spain",
    cx: 8,
    cy: 0.1,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_126",
    className: "st6-spain",
    cx: 8.2,
    cy: 0.3,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_127",
    className: "st6-spain",
    cx: 8.4,
    cy: 0.6,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_128",
    className: "st6-spain",
    cx: 8.4,
    cy: 0.9,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_129",
    className: "st6-spain",
    cx: 8.4,
    cy: 1.2,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_130",
    className: "st6-spain",
    cx: 8.3,
    cy: 1.4,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_131",
    className: "st6-spain",
    cx: 8.2,
    cy: 1.7,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    transform: "translate(0.377 3.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_321",
    className: "st3-spain",
    d: "M3.3,2.3C2.4,2.3,1.5,2.2,0.6,2c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1 c1.8-0.5,3.7-0.5,5.5,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1C5.2,2.2,4.3,2.3,3.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_322",
    className: "st3-spain",
    d: "M3.3,1.4c-0.9,0-1.9,0.1-2.8,0.4c0.1,0,0.1-0.1,0-0.3C0.5,1.3,0.3,1.3,0.3,1.3 c2-0.5,4.1-0.5,6,0c0,0-0.1,0-0.2,0.2c-0.1,0.2-0.1,0.3,0,0.3C5.2,1.5,4.3,1.4,3.3,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_323",
    className: "st3-spain",
    d: "M3.3,0.9c-1,0-2,0.1-3,0.4c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0 c2-0.5,4.1-0.5,6.1,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0C5.4,1,4.4,0.9,3.3,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_324",
    className: "st3-spain",
    d: "M3.3-0.1l0.1,0c0,0,0,0.1,0,0.1c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.1,0.4-0.3 c0,0,0-0.2,0.1-0.1c0,0,0,0.2,0,0.2c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0,0,0,0,0-0.1L5.4,0l0.1,0.2 c0,0.1,0,0.1,0,0.2c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0c0.1,0,0.3-0.1,0.3-0.2l0.1-0.1v0.1c0,0.1,0.1,0.3,0.2,0.3 c0.1,0,0.3-0.1,0.4-0.2C6.9,0.6,7,0.5,7.1,0.4l0,0.2C7,0.7,6.9,0.9,6.8,1C6.6,1,6.5,1.1,6.4,1.1C6.3,1,6.2,0.9,6.1,0.8 C6,0.9,5.9,0.9,5.8,0.9c-0.2,0-0.5-0.1-0.6-0.3C5.1,0.7,5,0.8,4.8,0.8c-0.2,0-0.4-0.1-0.5-0.2C3.8,0.3,3.2,0.4,2.8,0.7 c-0.2,0-0.3-0.1-0.4-0.2C2.3,0.7,2.1,0.8,1.9,0.8C1.7,0.5,1.3,0.5,1,0.7C1,0.8,0.9,0.8,0.9,0.9c-0.1,0-0.2,0-0.3-0.1 c0,0.1-0.1,0.2-0.3,0.2C0.2,1.1,0,1-0.1,1c-0.1-0.1-0.3-0.2-0.4-0.4l0-0.2c0.1,0.1,0.2,0.2,0.3,0.3C0,0.8,0.1,0.9,0.3,0.9 c0.1,0,0.2-0.1,0.2-0.3V0.5l0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0,0.4-0.2,0.4-0.4c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2L1.3,0 l0.1,0.1c0,0,0,0,0,0.1c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.1,0.4-0.4c0,0,0-0.2,0-0.2c0,0,0.1,0.2,0.1,0.1 c0.1,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.2,0.4-0.4c0-0.1,0-0.1,0-0.1L3.3-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_325",
    className: "st3-spain",
    d: "M-0.3,0.5C-0.4,0.5-0.4,0.5-0.3,0.5c-0.1-0.2-0.2-0.2-0.3-0.1c0,0,0,0,0,0 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1,0-0.2-0.1-0.3,0C-1.1,0-1-0.1-0.9-0.1c0,0,0,0,0,0c0.1,0,0.2,0,0.2,0.1l0-0.1 C-0.6-0.1-0.5,0-0.5,0c0,0.1,0,0.2,0,0.3c0-0.1,0-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0.1,0.1c0,0,0,0,0,0L0,0.5c-0.1,0-0.2,0-0.2,0 C-0.2,0.5-0.3,0.5-0.3,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_326",
    className: "st2-spain",
    d: "M-0.6,0.4c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.1,0,0.2c-0.1,0-0.2,0-0.2,0 C-0.6,0.5-0.7,0.5-0.6,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_327",
    className: "st6-spain",
    d: "M0.4,0.5c0-0.1,0-0.1,0.1-0.2s0.1,0,0.1,0.1c0,0.1,0,0.1-0.1,0.2C0.5,0.6,0.4,0.6,0.4,0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_328",
    className: "st3-spain",
    d: "M1.2,0.1C1.2,0.1,1.2,0.1,1.2,0.1C1.2,0,1.2,0,1.2-0.1c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.1,0-0.2,0H0.7c0,0,0,0,0,0c0,0,0,0,0,0.1C0.7,0,0.6,0.1,0.5,0.1c0-0.1,0.1-0.1,0.2-0.1s0.1,0.1,0.1,0.2c0,0,0,0,0,0.1 l0.1,0C1,0.3,1,0.3,1.1,0.2C1.1,0.2,1.2,0.2,1.2,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    className: "st3-spain",
    d: "M1.2-0.8c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0-0.1-0.1-0.1-0.1C1-0.3,1-0.4,1-0.4 c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0C1.1-0.6,1.1-0.7,1.2-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_330",
    className: "st3-spain",
    d: "M1.5,0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1 l0.1,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0.1,0,0.2,0,0.3,0.1C2.1,0,2,0,1.9,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1H1.8 c-0.1,0-0.1,0-0.2,0C1.6,0.1,1.5,0.1,1.5,0.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_132",
    className: "st2-spain",
    cx: 1.3,
    cy: 0,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_331",
    className: "st6-spain",
    d: "M2.3,0.1C2.2,0,2.3,0,2.3,0C2.4,0,2.4,0,2.5,0.1c0,0.1,0,0.1-0.1,0.2S2.3,0.2,2.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_332",
    className: "st3-spain",
    d: "M3.2-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1C3.1-0.3,3.1-0.4,3-0.4c-0.1,0-0.2,0-0.2-0.1 l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.2,0.1-0.3,0.2C2.5-0.1,2.6,0,2.7,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1l0.1,0 C2.9,0.1,3.1,0,3.2-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_333",
    className: "st3-spain",
    d: "M3.3-1.1C3.4-1,3.5-0.9,3.5-0.7c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1 c0,0,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c-0.1-0.1-0.2-0.1-0.3,0c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.2C3.1-0.5,3-0.6,3-0.7 c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0C3.2-0.9,3.2-1,3.3-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_334",
    className: "st3-spain",
    d: "M3.5-0.1c0.1-0.1,0.1-0.2,0-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2-0.1l0.1,0 c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0.1,0,0.2,0.1,0.3,0.2C4.2-0.1,4.1,0,3.9,0C4,0,4,0,4,0.1c0,0,0,0,0,0.1l-0.1,0 C3.7,0.1,3.6,0,3.5-0.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_133",
    className: "st2-spain",
    cx: 3.3,
    cy: -0.2,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_335",
    className: "st6-spain",
    d: "M4.4,0.1C4.5,0,4.4,0,4.4,0C4.3,0,4.3,0,4.2,0.1s0,0.1,0.1,0.2S4.4,0.2,4.4,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_336",
    className: "st3-spain",
    d: "M5.2,0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1-0.1-0.1-0.1C5.1-0.3,5-0.3,4.9-0.3 l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.2,0-0.3,0.1C4.6,0,4.7,0,4.8,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1h0.1 c0.1,0,0.1,0,0.2,0C5.1,0.1,5.2,0.1,5.2,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_337",
    className: "st3-spain",
    d: "M5.5-0.8C5.4-0.7,5.3-0.6,5.3-0.5c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.2 s0.1-0.1,0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0C5.6-0.6,5.6-0.7,5.5-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_338",
    className: "st3-spain",
    d: "M5.5,0.1C5.5,0.1,5.5,0.1,5.5,0.1C5.5,0,5.5,0,5.5-0.1c0.1,0,0.1,0,0.2-0.1 c0.1,0,0.1,0,0.2,0H6c0,0,0,0,0,0c0,0,0,0,0,0.1C6,0,6.1,0.1,6.2,0.1C6.1,0.2,6,0.2,5.9,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1 l-0.1,0c-0.1,0-0.1-0.1-0.2-0.1C5.6,0.2,5.5,0.2,5.5,0.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_134",
    className: "st2-spain",
    cx: 5.4,
    cy: 0,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_339",
    className: "st6-spain",
    d: "M6.3,0.5c0-0.1,0-0.1-0.1-0.2s-0.1,0-0.1,0.1c0,0.1,0,0.1,0,0.2C6.2,0.6,6.3,0.6,6.3,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_340",
    className: "st3-spain",
    d: "M7,0.5C7,0.5,7.1,0.5,7,0.5c0.1-0.2,0.2-0.2,0.3-0.1c0,0,0,0,0,0c0.1-0.1,0.1-0.2,0.2-0.3 c0.1,0,0.2-0.1,0.3,0c0-0.1-0.1-0.3-0.3-0.3c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0.1l0-0.1C7.3-0.1,7.2,0,7.2,0c0,0.1,0,0.2,0,0.3 c0-0.1,0-0.1-0.1-0.1C7,0.2,7,0.1,6.9,0.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.2,0-0.3,0 c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0-0.1,0.1c0,0,0,0,0,0l0.1,0c0.1,0,0.2,0,0.2,0C6.9,0.5,7,0.5,7,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_341",
    className: "st2-spain",
    d: "M7.3,0.4c-0.1,0-0.2,0-0.2,0C7,0.5,7,0.6,7,0.6c0.1,0,0.2,0,0.2,0 C7.3,0.5,7.4,0.5,7.3,0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    transform: "translate(2.02 5.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_342",
    className: "st2-spain",
    d: "M1.7-0.1C0.8-0.1,0-0.2-0.8-0.4c1.7-0.4,3.4-0.4,5.1,0C3.4-0.2,2.6-0.1,1.7-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_343",
    className: "st4-spain",
    d: "M2.4-0.1v-0.5 M2.1-0.1v-0.6 M1.9-0.1v-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_344",
    className: "st4-spain",
    d: "M1.8-0.1v-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_345",
    className: "st4-spain",
    d: "M1.6-0.1v-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_346",
    className: "st4-spain",
    d: "M1.5-0.1v-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_347",
    className: "st4-spain",
    d: "M1.3-0.1v-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_348",
    className: "st4-spain",
    d: "M1.2-0.1v-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_349",
    className: "st4-spain",
    d: "M0.9-0.1v-0.5 M1.1-0.1v-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_350",
    className: "st4-spain",
    d: "M0.7-0.2v-0.5 M0.8-0.1v-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_351",
    className: "st4-spain",
    d: "M0.4-0.2v-0.4 M0.5-0.2v-0.5 M0.6-0.2v-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_352",
    className: "st4-spain",
    d: "M0.3-0.2v-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_353",
    className: "st4-spain",
    d: "M0.2-0.2v-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_354",
    className: "st4-spain",
    d: "M0.1-0.2v-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_355",
    className: "st4-spain",
    d: "M-0.1-0.3v-0.3 M0-0.2v-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_356",
    className: "st4-spain",
    d: "M-0.3-0.3v-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    className: "st4-spain",
    d: "M-0.4-0.3v-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_358",
    className: "st4-spain",
    d: "M-0.5-0.3v-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_359",
    className: "st4-spain",
    d: "M-0.6-0.3v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_360",
    className: "st4-spain",
    d: "M-0.7-0.4L-0.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_361",
    className: "st4-spain",
    d: "M-0.9-0.4c1.7-0.4,3.6-0.4,5.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_362",
    className: "st2-spain",
    d: "M-1.2-0.8l0.1-0.1l0.3,0l-0.2,0.2L-1.2-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_363",
    className: "st6-spain",
    d: "M-0.6-0.9C-0.6-1-0.6-1-0.6-0.9C-0.5-1-0.4-1-0.4-0.9C-0.4-0.9-0.5-0.8-0.6-0.9 C-0.6-0.8-0.6-0.9-0.6-0.9L-0.6-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_364",
    className: "st5-spain",
    d: "M0.2-1L0-0.9C0-0.9-0.1-1-0.1-1c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0,0l0.2,0l0.2,0 c0.1,0,0.1,0,0.1,0.1C0.5-1,0.5-1,0.5-1L0.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_365",
    className: "st6-spain",
    d: "M0.9-1.1C0.9-1.2,0.9-1.2,0.9-1.1C1-1.2,1-1.2,1-1.1C1-1.1,1-1,0.9-1.1 C0.9-1,0.9-1.1,0.9-1.1L0.9-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_366",
    className: "st2-spain",
    d: "M1.7-1H1.4c-0.1,0-0.1,0-0.1-0.1v0c0-0.1,0-0.1,0.1-0.1h0H2c0.1,0,0.1,0,0.1,0.1v0 C2.1-1.1,2-1,2-1h0H1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_367",
    className: "st6-spain",
    d: "M2.4-1.1C2.4-1.2,2.4-1.2,2.4-1.1c0.1-0.1,0.2-0.1,0.2,0C2.5-1.1,2.5-1,2.4-1.1 C2.4-1,2.4-1.1,2.4-1.1L2.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_368",
    className: "st5-spain",
    d: "M3.2-1l0.2,0c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.1c0,0,0,0,0,0l-0.2,0 L3-1.2c-0.1,0-0.1,0-0.1,0.1C2.9-1,2.9-1,2.9-1l0,0L3.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_369",
    className: "st6-spain",
    d: "M3.8-0.9C3.8-1,3.9-1,3.8-0.9C4-1,4-1,4-0.9C4-0.9,4-0.8,3.8-0.9C3.9-0.8,3.8-0.9,3.8-0.9 L3.8-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_370",
    className: "st2-spain",
    d: "M4.6-0.8L4.5-0.9l-0.3,0l0.2,0.2L4.6-0.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(4.145 6.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Granada",
    transform: "translate(0.014 5.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_371",
    className: "st8-spain",
    d: "M3.3,4C2.2,4,1,3.8,0,3.3c-0.7-0.4-1.2-1.1-1.2-1.9v-3h8.9v3c0,0.8-0.5,1.5-1.2,1.9 C5.5,3.8,4.4,4,3.3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_372",
    className: "st9-spain",
    d: "M3.5,2.7c0.2,0,0.3,0.2,0.3,0.4c0,0.2-0.2,0.4-0.5,0.4c0,0,0,0,0,0 c-0.2,0-0.4-0.1-0.5-0.4c0-0.2,0.1-0.3,0.3-0.4c0,0,0,0,0,0L3,2.6c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0,0,0,0,0.1,0 c0,0,0,0,0.1,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0C3.5,2.6,3.5,2.6,3.5,2.7C3.5,2.7,3.5,2.7,3.5,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_373",
    className: "st5-spain",
    d: "M3.3,3.7C3.1,3.6,2.9,3.5,2.8,3.4c-0.2,0-0.3,0-0.5,0c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.2,0.1,0.3,0.2C2.9,3.7,3.1,3.7,3.3,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_374",
    className: "st5-spain",
    d: "M3.4,3.7c0.1-0.1,0.3-0.2,0.5-0.3c0.2,0,0.4,0,0.6,0.1c0,0-0.1,0-0.1,0.1 C4.2,3.6,4,3.7,3.9,3.7C3.7,3.7,3.5,3.7,3.4,3.7L3.4,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_375",
    className: "st2-spain",
    d: "M3.3,3.4c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0 C3.4,2.8,3.4,3,3.4,3.1C3.4,3.2,3.4,3.3,3.3,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_376",
    className: "st5-spain",
    d: "M3.2,3.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.1,0-0.2h0.1c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1,0,0.2C3.3,3.9,3.3,3.9,3.2,3.9C3.3,3.9,3.2,3.9,3.2,3.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Aragon",
    transform: "translate(0 5.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_377",
    className: "st2-spain",
    d: "M3.3,1.5c0,1.2-1,2.2-2.3,2.2c-1.2,0-2.1-1-2.2-2.2v-3h4.4V1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_378",
    className: "st3-spain",
    d: "M-1.1,1.4c0,0.5,0.2,1,0.5,1.4v-4.5h-0.5L-1.1,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_379",
    className: "st3-spain",
    d: "M-0.2,3.3C0,3.4,0.2,3.4,0.4,3.5l0-5.1h-0.5L-0.2,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_380",
    className: "st3-spain",
    d: "M0.8,3.6c0.2,0,0.3,0,0.5,0v-5.2H0.8V3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_381",
    className: "st3-spain",
    d: "M1.8,3.5c0.2,0,0.4-0.1,0.5-0.2v-4.9H1.8L1.8,3.5L1.8,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_382",
    className: "st3-spain",
    d: "M2.8,2.8c0.3-0.3,0.5-0.7,0.5-1.2l0-3.3H2.8L2.8,2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Navarre",
    transform: "translate(4.723 5.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_383",
    className: "st2-spain",
    d: "M3-1.6v3c0,1.2-1.1,2.2-2.3,2.1c-1.2,0-2.1-1-2.1-2.1v-3H3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chains_half",
    className: "st3-spain",
    d: "M0.5,0.6C0.5,0.6,0.5,0.6,0.5,0.6L0.2,0.1L0,0.2l-0.3-0.3l0.1-0.1l-0.5-0.5h0v0.4l0.2,0V0 l-0.2,0v0.4c0.1,0,0.1,0.1,0.2,0.2h0.3l0-0.2h0.4l0,0.2L0.5,0.6z M-0.1-1.1v0.1h0.2v-0.1H-0.1z M-0.7,0.8c0.1,0,0.1,0,0.1-0.1 c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1C-0.8,0.7-0.8,0.8-0.7,0.8C-0.7,0.8-0.7,0.8-0.7,0.8L-0.7,0.8z M0.7-0.1l-0.2,0v-0.4 l0.2,0v-0.2c-0.1,0-0.1-0.1-0.2-0.2H0.3l0,0.2h-0.4l0-0.2h-0.3c0,0,0,0,0,0.1L0-0.3l0.1-0.1l0.3,0.3L0.3,0.1l0.4,0.4l0,0 L0.7-0.1z M0-0.2l-0.1,0.1L0.1,0L0.2,0L0-0.2z M0.7,3C0.6,3,0.6,3,0.5,2.9c-0.1,0-0.3-0.1-0.4-0.1l0.1-0.1 c0.1,0,0.2,0.1,0.4,0.1c0-0.1,0.1-0.1,0.1-0.1V2.1L0.5,2V1.6l0.2,0V0.9c0,0,0,0,0,0L0.3,1.3l0.1,0.1L0.1,1.7L0,1.7L-0.3,2 c0.1,0.1,0,0.2,0,0.3C-0.2,2.3-0.1,2.4,0,2.5l-0.1,0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2,0-0.3 c0,0,0,0,0,0l0,0c-0.1-0.1-0.1-0.3-0.1-0.5h0.2c0,0.1,0,0.3,0.1,0.4c0,0,0.1,0,0.1,0l0.3-0.3l-0.1-0.1L0,1.1l0.1,0.1l0.4-0.4 c0,0,0,0,0,0H0.3l0,0.2h-0.4l0-0.2h-0.3c0,0.1-0.1,0.1-0.1,0.1v0.4h-0.2V0.9C-0.9,0.9-1,0.8-1,0.7c0-0.1,0.1-0.2,0.2-0.2V0.1 L-1,0v-0.4l0.2,0v-0.4C-0.9-0.8-1-0.9-1-1c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.2h0.3l0-0.2h0.4l0,0.2h0.2 c0-0.1,0.1-0.2,0.2-0.2l0,0.8H0.7v0.2h0.1v1.9H0.7V2h0.1L0.7,3z M0.2,1.4L0.1,1.3L0,1.5l0.1,0.1L0.2,1.4z M-0.6-0.3h-0.1V0h0.2 L-0.6-0.3z M0.2,0.8V0.6h-0.3v0.1H0.2z M-0.8,1.6l-0.2,0l0-0.4l0.2-0.1v0.2C-0.8,1.5-0.8,1.5-0.8,1.6L-0.8,1.6z M-0.7,1.1l0.2,0 c0,0,0,0.3,0,0.2s0,0.2,0,0.2l-0.2,0.1c0-0.1,0-0.2,0-0.3L-0.7,1.1z M0.3,2.7l0-0.2C0.2,2.5,0.1,2.4,0,2.3l-0.1,0.1 C0,2.5,0.1,2.6,0.3,2.7L0.3,2.7z M0.2,2.8L0.1,2.9C0,2.9-0.1,2.8-0.3,2.7l0-0.2C-0.1,2.7,0.1,2.7,0.2,2.8L0.2,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_384",
    className: "st3-spain",
    d: "M1,0.6C1,0.6,1,0.6,1,0.6l0.4-0.5l0.1,0.1l0.3-0.3L1.7-0.2l0.5-0.5h0v0.4L2-0.4V0l0.2,0 v0.4C2.1,0.5,2,0.5,2,0.6H1.7l0-0.2H1.3l0,0.2L1,0.6z M1.6-1.1v0.1H1.4v-0.1L1.6-1.1z M2.2,0.8C2.2,0.8,2.1,0.7,2.2,0.8 c-0.1-0.2-0.1-0.2,0-0.2c0,0,0,0,0,0C2.3,0.6,2.3,0.6,2.2,0.8C2.3,0.7,2.3,0.8,2.2,0.8C2.2,0.8,2.2,0.8,2.2,0.8z M0.8-0.1l0.2,0 v-0.4l-0.2,0v-0.2C0.9-0.8,1-0.8,1-0.9h0.2l0,0.2h0.4l0-0.2H2c0,0,0,0,0,0.1L1.6-0.3L1.4-0.4L1.1-0.1l0.1,0.1L0.9,0.5l0,0V-0.1z  M1.5-0.2l0.1,0.1L1.4,0L1.3,0L1.5-0.2z M0.8,3C0.9,3,1,3,1,2.9c0.1,0,0.3-0.1,0.4-0.1L1.3,2.6C1.2,2.7,1.1,2.7,1,2.7 c0-0.1-0.1-0.1-0.1-0.1V2.1L1,2V1.6l-0.2,0V0.9c0,0,0,0,0,0l0.4,0.4L1.1,1.4l0.3,0.3l0.1-0.1L1.8,2c-0.1,0.1,0,0.2,0,0.3 C1.7,2.3,1.6,2.4,1.5,2.5l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.2,0,0.2,0c0.1-0.1,0.1-0.2,0-0.3c0,0,0,0,0,0l0,0 c0.1-0.1,0.1-0.3,0.1-0.5H2.2c0,0.1,0,0.3-0.1,0.4c0,0-0.1,0-0.1,0L1.6,1.6l0.1-0.1L1.5,1.1L1.3,1.2L1,0.8c0,0,0,0,0,0h0.2 l0,0.2h0.4l0-0.2H2c0,0.1,0.1,0.1,0.1,0.1v0.4h0.2V0.9c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2V0.1l0.2,0v-0.4l-0.2,0v-0.4 c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0C2.1-1.2,2-1.2,2-1.1H1.7l0-0.2H1.3l0,0.2H1c0-0.1-0.1-0.2-0.2-0.2 l0,0.8h0.1v0.2H0.8v1.9h0.1V2H0.8L0.8,3z M1.3,1.4l0.1-0.1l0.2,0.2L1.4,1.6L1.3,1.4z M2.2-0.3h0.1V0H2.2L2.2-0.3z M1.4,0.8V0.6 h0.3v0.1L1.4,0.8z M2.3,1.6l0.2,0l0-0.4L2.3,1.1v0.2C2.3,1.5,2.3,1.5,2.3,1.6z M2.2,1.1L2,1.2c0,0,0,0.3,0,0.2s0,0.2,0,0.2 l0.1,0.1c0-0.1,0-0.2,0-0.3L2.2,1.1z M1.2,2.7l0-0.2c0.1,0,0.3-0.1,0.4-0.2l0.1,0.1C1.5,2.5,1.4,2.6,1.2,2.7z M1.3,2.8l0.1,0.1 c0.1,0,0.3-0.1,0.4-0.2l0-0.2C1.6,2.6,1.4,2.7,1.3,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_385",
    className: "st5-spain",
    d: "M0.5,0.7c0-0.1,0.1-0.2,0.2-0.2C0.9,0.4,1,0.5,1,0.7c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0 C0.6,0.9,0.5,0.8,0.5,0.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Castile",
    transform: "translate(0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_386",
    className: "st2-spain",
    d: "M-1.2,3.7h4.4v-5h-4.4V3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_387",
    className: "st3-spain",
    d: "M0.4-0.1L0.4-0.1L0.4-0.1L0.1-0.2v0.3h0.1v0.2H0V1h0.2v1.3h-0.3V3h2.5V2.3H2V1h0.2V0.3 H1.9V0.1H2v-0.3H1.9v0.1H1.8v-0.1H1.6v0.1H1.5v-0.1H1.4v0.3h0.1v0.2H1.2v-0.7h0.2v-0.3H1.2v0.1H1.1v-0.1H1v0.1H0.9v-0.1H0.8v0.3 h0.2v0.7H0.6V0.1h0.1v-0.3H0.6v0.1H0.5v-0.1L0.4-0.1L0.4-0.1z M-0.2,3h2.5 M-0.2,2.9h2.5 M-0.2,2.7h2.5 M-0.2,2.5h2.5 M-0.2,2.3 h2.5 M0.1,2.2H2 M0.1,2H2 M0.1,1.8H2 M0.1,1.7H2 M0.1,1.5H2 M0.1,1.3H2 M0.1,1.2H2 M0,1h2.2 M0,0.8h2.2 M0,0.7h2.2 M0,0.5h2.2  M0.3,0.3h1.6 M0.9,0.2h0.3 M0.9,0h0.3 M0.9-0.2h0.3 M0.9-0.3h0.3 M0.8-0.6h0.6 M0.3,0.2h0.3 M0.1-0.1h0.6 M0.1,3V2.8 M0.1,2.7 V2.5 M0,2.7v0.2 M0.3,2.9V2.7 M0.4,3V2.8 M0.4,2.7V2.5 M0.4,2.3V2.2 M0.4,2V1.8 M0.3,2.5V2.3 M0,2.5V2.3 M0.6,2.3v0.2 M0.8,2.3 V2.2 M0.3,2v0.2 M0.6,2v0.2 M0.9,2v0.2 M0.8,2V1.8 M0.9,1.7v0.2 M0.9,1.3v0.2 M0.8,1.2v0.2 M0.9,1v0.2 M0.6,1v0.2 M0.3,1v0.2  M0.1,0.8V1 M0.4,0.8V1 M0.8,0.8V1 M0.9,0.7v0.2 M0.6,0.7v0.2 M0.3,0.7v0.2 M0.1,0.5v0.2 M0.8,0.5v0.2 M0.4,0.2v0.2 M1.9,0.2 H1.5 M2,0H1.4 M2,3V2.8 M2,2.7V2.5 M2.2,2.7v0.2 M1.9,2.9V2.7 M1.7,3V2.8 M1.7,2.7V2.5 M1.7,2.3V2.2 M1.7,2V1.8 M1.9,2.5V2.3  M2.2,2.5V2.3 M1.5,2.3v0.2 M1.4,2.3V2.2 M1.9,2v0.2 M1.5,2v0.2 M1.2,2v0.2 M1.4,2V1.8 M1.2,1.7v0.2 M1.2,1.3v0.2 M1.4,1.2v0.2  M1.2,1v0.2 M1.5,1v0.2 M1.9,1v0.2 M2,0.8V1 M1.7,0.8V1 M1.4,0.8V1 M1.2,0.7v0.2 M1.5,0.7v0.2 M1.9,0.7v0.2 M2,0.5v0.2 M1.4,0.5 v0.2 M1.7,0.2v0.2 M1.1,2V1.8 M1.1,1.3V1.2 M1.1,1.7V1.5 M1.1,1V0.8 M1.1,0.7V0.5 M1.1,0.2V0 M1.1-0.2v-0.2 M0.3,0.1h0.3  M0.9-0.4h0.3 M1.5,0.1h0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_388",
    className: "st3-spain",
    d: "M1.5,3V2.6c0-0.1,0-0.3-0.4-0.3c-0.4,0-0.4,0.3-0.4,0.3V3H1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_389",
    className: "st3-spain",
    d: "M0.8,2.6l-0.2,0c0-0.1,0-0.2,0.1-0.2l0.2,0.1C0.8,2.5,0.8,2.6,0.8,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_390",
    className: "st3-spain",
    d: "M1.1,2.4l0.1-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0L1,2.4H1.1L1.1,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_391",
    className: "st3-spain",
    d: "M1.3,2.6l0.2,0c0-0.1,0-0.2-0.1-0.2L1.3,2.5C1.3,2.5,1.3,2.6,1.3,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_392",
    className: "st3-spain",
    d: "M0.8,1.9V1.4c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0v0.5H0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_393",
    className: "st3-spain",
    d: "M1.4,1.9V1.4c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2c0,0,0,0,0,0v0.5H1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_394",
    className: "st3-spain",
    d: "M0.6,0.7l0-0.4H0.2l0,0.4H0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_395",
    className: "st3-spain",
    d: "M1.2,0.7l0-0.4H0.9l0,0.4H1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_396",
    className: "st3-spain",
    d: "M1.5,0.7l0-0.4h0.4l0,0.4H1.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    transform: "translate(1.596 2.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_397",
    className: "st1-spain0",
    d: "M-0.2,0.3v-0.4c0-0.1-0.1-0.3-0.3-0.3c0,0,0,0,0,0c-0.1,0-0.3,0.1-0.3,0.2c0,0,0,0,0,0 v0.4H-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_398",
    className: "st1-spain0",
    d: "M-0.9-0.9v-0.4c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2,0-0.2,0.1c0,0,0,0.1,0,0.1v0.4H-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_399",
    className: "st1-spain0",
    d: "M-0.2-0.9v-0.4c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1c0,0,0,0.1,0,0.1v0.4H-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Leon",
    transform: "translate(4.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_400",
    className: "st8-spain",
    d: "M-1.4,3.7H3v-5h-4.4V3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_401",
    className: "st1-spain1",
    d: "M0.8-0.1L0.8-0.1L0.8-0.1C0.8-0.2,0.7-0.2,0.6-0.2c-0.1,0-0.2-0.1-0.2-0.1 C0.3-0.3,0.3-0.4,0.3-0.4c-0.1,0-0.1,0-0.2,0c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0 C0.7-0.1,0.8-0.1,0.8-0.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    transform: "translate(0.771 0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_402",
    className: "st1-spain2",
    d: "M0.7-1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1l-0.1,0 c0,0-0.1,0-0.1,0l0,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2 c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0.1,0,0.1c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.3,0.5,0.3s0.2-0.4,0.1-0.6 c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0.1-0.3,0-0.3c0-0.1,0-0.2,0-0.3C1.2-0.9,1.2-1,1.2-1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0.1,0,0.2-0.1,0.2 c0,0-0.2,0.2-0.2,0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0-0.1,0.1-0.1,0.1c-0.1,0.1,0,0.1-0.1,0.2S1.3-0.5,1.3-0.5 c-0.1,0.1,0,0.4,0,0.4c0.1,0.2,0.1,0.3,0.2,0.5c0,0.2,0,0.3-0.1,0.4C1.2,1,1,1,1,1C0.9,1.1,0.8,1.2,0.8,1.3 c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0-0.1,0.1-0.1,0.2C1,2,1,2,0.9,2.1c0,0,0,0.1,0,0.1 c0,0,0.1,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1s0,0,0,0c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1H0.2c-0.1,0-0.1,0-0.1,0c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1-0.1,0.1 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0.1,0,0.1,0,0.1c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1s0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0-0.1s-0.1-0.1,0-0.1s0.1,0,0.1,0s0,0,0-0.1 c0,0-0.1,0,0-0.1c0,0,0,0,0.1,0c0,0,0-0.1,0.1-0.1c0.1,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0-0.1-0.1,0-0.1c0-0.1,0-0.2,0-0.2s0.1-0.1,0.2-0.2s0.2,0,0.2,0s0.2,0,0.2,0S0,0.7-0.1,0.7 c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0.1,0,0.1-0.1,0.2c-0.1,0-0.1,0.1-0.1,0.1s0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0-0.1,0.1-0.1,0.1 c-0.1,0-0.2,0-0.2,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0-0.1 c0,0-0.1,0-0.1,0s-0.1,0-0.1,0s0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0c0,0,0,0-0.1-0.1s-0.1,0-0.1-0.1c0,0,0,0,0-0.1 c0,0,0-0.1,0.1,0c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1S-0.7,0-0.8,0 c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2,0c0,0,0,0,0.1,0c0,0,0.1-0.1,0.1,0h0c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1-0.1-0.1s0-0.1-0.1-0.1 s-0.1,0-0.1,0c0,0,0,0-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1,0-0.1s0.1,0,0.1,0s0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0.1,0,0.1-0.1 S-1.4-1-1.4-1s0.1,0.1,0.1,0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0,0,0.1,0C-1.1-1-1-1-1-1c0,0,0,0.1-0.1,0.1c0,0,0,0.1,0,0.1 c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0 c0.1,0,0.1-0.1,0.1-0.1s-0.1-0.1-0.1-0.1s0,0,0.1,0S0-0.7,0-0.8S0.1-0.9,0-1s-0.2,0-0.2-0.1s0-0.1,0-0.1c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.2,0.2C0.6-1.1,0.6-1.1,0.7-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_406",
    d: "M0.6-0.3C0.6-0.3,0.6-0.4,0.6-0.3C0.5-0.4,0.5-0.4,0.6-0.3C0.5-0.4,0.6-0.4,0.6-0.3 C0.6-0.4,0.6-0.4,0.6-0.3C0.6-0.4,0.6-0.4,0.6-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_407",
    d: "M0.9-0.5L0.9-0.5C1-0.5,1-0.5,0.9-0.5c0.1,0,0.2,0,0.2,0.1C1.1-0.4,1-0.4,0.9-0.5C1-0.4,1-0.4,0.9-0.5 C1-0.4,1-0.4,0.9-0.5C0.9-0.5,0.9-0.5,0.9-0.5L0.9-0.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    transform: "translate(2.141 1.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_408",
    d: "M-1.6-1.1L-1.6-1.1L-1.6-1.1L-1.6-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_409",
    d: "M-1.5-1.1L-1.5-1.1L-1.5-1.1L-1.5-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_410",
    d: "M-1.5-1.4L-1.5-1.4L-1.5-1.4L-1.5-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_411",
    d: "M-1.4-1.4L-1.4-1.4L-1.4-1.4L-1.4-1.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    transform: "translate(0.609 0.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_412",
    className: "st1-spain1",
    d: "M-1-1.2C-1-1.2-1-1.2-1-1.2c0.1,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.1-0.1 C-1-1.4-1-1.3-1-1.2C-1-1.2-1-1.2-1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_413",
    className: "st1-spain1",
    d: "M-1.2-1.1c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1 C-1.3-1-1.3-1-1.2-1.1C-1.3-1.1-1.2-1.1-1.2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_414",
    className: "st1-spain1",
    d: "M-1.3-0.8c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 C-1.3-0.7-1.3-0.7-1.3-0.8C-1.3-0.8-1.3-0.8-1.3-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_415",
    className: "st1-spain1",
    d: "M-1.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0,0.1,0,0.1,0C-1.2,0.2-1.2,0.2-1.1,0.1 C-1.2,0.2-1.1,0.2-1.1,0.1C-1.1,0.1-1.1,0.1-1.1,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_416",
    className: "st1-spain1",
    d: "M-1.2,0.4c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 C-1.2,0.5-1.2,0.5-1.2,0.4C-1.2,0.4-1.2,0.4-1.2,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_417",
    className: "st1-spain1",
    d: "M-1,0.6c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1 C-0.9,0.6-0.9,0.6-1,0.6C-1,0.6-1,0.6-1,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_418",
    className: "st1-spain1",
    d: "M-0.4,1.3c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1 C-0.5,1.3-0.5,1.3-0.4,1.3C-0.4,1.3-0.4,1.3-0.4,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_419",
    className: "st1-spain1",
    d: "M-0.6,1.5c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0 C-0.6,1.6-0.6,1.6-0.6,1.5C-0.6,1.5-0.6,1.5-0.6,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_420",
    className: "st1-spain1",
    d: "M-0.4,1.8c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1C-0.3,1.9-0.3,1.9-0.4,1.8 c0.1,0.1,0.1,0,0.1,0L-0.4,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_421",
    className: "st1-spain1",
    d: "M0.7,1.9c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1S0.6,2,0.7,1.9c0,0.1,0,0.1,0,0.1 C0.7,2,0.7,1.9,0.7,1.9C0.7,1.9,0.7,1.9,0.7,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    className: "st1-spain1",
    d: "M0.7,2.1c0,0-0.1,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0 C0.8,2.2,0.8,2.2,0.7,2.1C0.8,2.2,0.7,2.1,0.7,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    className: "st1-spain1",
    d: "M1,2.2c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0.1C1.1,2.4,1.1,2.3,1,2.2c0.1,0,0.1,0,0.1,0 C1.1,2.2,1.1,2.2,1,2.2C1,2.2,1,2.2,1,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    transform: "translate(2.576 0.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    className: "st3-spain",
    d: "M-1.1-1L-1.1-1C-1.2-1-1.2-1-1.1-1C-1.2-1-1.2-1-1.3-1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0v0l0,0l0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1l0,0 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0.2,0.1,0.4,0.2,0.5,0.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0-0.1l0,0v0h0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0C-1.1-0.9-1.2-0.9-1.1-1C-1.2-0.9-1.2-0.9-1.1-1 C-1.2-1-1.1-1-1.1-1L-1.1-1L-1.1-1L-1.1-1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    transform: "translate(0.1 0.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    d: "M-1.4-1.2C-1.4-1.3-1.4-1.3-1.4-1.2C-1.4-1.2-1.4-1.2-1.4-1.2C-1.4-1.2-1.4-1.2-1.4-1.2 C-1.4-1.2-1.4-1.2-1.4-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    d: "M-1.4-1.2L-1.4-1.2C-1.4-1.2-1.4-1.2-1.4-1.2C-1.4-1.2-1.4-1.2-1.4-1.2L-1.4-1.2L-1.4-1.2 C-1.3-1.2-1.3-1.2-1.4-1.2C-1.3-1.1-1.3-1.1-1.4-1.2L-1.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    d: "M-1.5-1.3L-1.5-1.3C-1.5-1.3-1.5-1.3-1.5-1.3C-1.5-1.3-1.5-1.3-1.5-1.3C-1.5-1.3-1.5-1.3-1.5-1.3 L-1.5-1.3L-1.5-1.3C-1.5-1.3-1.5-1.3-1.5-1.3C-1.5-1.3-1.5-1.3-1.5-1.3C-1.5-1.3-1.5-1.3-1.5-1.3L-1.5-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_428",
    d: "M-1.6-1.3C-1.6-1.4-1.6-1.4-1.6-1.3C-1.6-1.3-1.6-1.3-1.6-1.3C-1.6-1.3-1.6-1.3-1.6-1.3 C-1.6-1.3-1.6-1.3-1.6-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_429",
    d: "M-1.3-1.1C-1.3-1.1-1.3-1.1-1.3-1.1C-1.3-1.1-1.3-1.1-1.3-1.1C-1.3-1.1-1.3-1.1-1.3-1.1 C-1.3-1.1-1.3-1.1-1.3-1.1L-1.3-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_430",
    d: "M-1.2-1L-1.2-1C-1.2-1-1.2-1-1.2-1C-1.2-1-1.2-1-1.2-1L-1.2-1L-1.2-1C-1.2-1.1-1.2-1.1-1.2-1 C-1.2-1.1-1.2-1.1-1.2-1L-1.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_431",
    d: "M-1.1-1C-1.1-1-1.1-1-1.1-1C-1.1-1-1.1-1-1.1-1C-1.1-1-1.1-1-1.1-1C-1.1-1-1.1-1-1.1-1 C-1.1-1-1.1-1-1.1-1C-1.1-1-1.1-1-1.1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_432",
    className: "st3-spain",
    d: "M-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_433",
    className: "st3-spain",
    d: "M-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2L-1.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    className: "st3-spain",
    d: "M-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    className: "st3-spain",
    d: "M-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    className: "st3-spain",
    d: "M-1.3-1.1C-1.3-1.2-1.3-1.2-1.3-1.1C-1.3-1.1-1.3-1.1-1.3-1.1C-1.3-1.1-1.3-1.1-1.3-1.1 C-1.3-1.1-1.3-1.1-1.3-1.1C-1.4-1.1-1.4-1.1-1.3-1.1C-1.4-1.1-1.3-1.1-1.3-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    className: "st3-spain",
    d: "M-1.5-1.2C-1.5-1.2-1.6-1.3-1.5-1.2c0-0.1,0-0.1-0.1-0.1C-1.6-1.3-1.5-1.3-1.5-1.2 C-1.5-1.3-1.5-1.2-1.5-1.2C-1.5-1.2-1.5-1.2-1.5-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_438",
    className: "st3-spain",
    d: "M-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2L-1.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_439",
    className: "st3-spain",
    d: "M-1.5-1.2C-1.5-1.2-1.5-1.3-1.5-1.2C-1.5-1.2-1.5-1.2-1.5-1.2C-1.5-1.2-1.5-1.2-1.5-1.2 C-1.6-1.2-1.6-1.2-1.5-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_440",
    className: "st3-spain",
    d: "M-1.1-1.1L-1.1-1.1L-1.1-1.1L-1.1-1.1L-1.1-1.1L-1.1-1.1L-1.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_441",
    className: "st3-spain",
    d: "M-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1L-1.2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_442",
    className: "st3-spain",
    d: "M-1.1-0.9L-1.1-0.9L-1.1-0.9L-1.1-0.9L-1.1-0.9L-1.1-0.9L-1.1-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_443",
    className: "st3-spain",
    d: "M-1.2-1C-1.2-1-1.1-1-1.2-1C-1.1-1-1.1-1-1.2-1C-1.1-1-1.1-1-1.2-1C-1.1-1-1.2-1-1.2-1 C-1.2-1-1.2-1-1.2-1C-1.2-1-1.2-1-1.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_444",
    className: "st3-spain",
    d: "M-0.9-0.9L-0.9-0.9L-0.9-0.9L-0.9-0.9L-0.9-0.9L-0.9-0.9L-0.9-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_445",
    className: "st3-spain",
    d: "M-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_446",
    className: "st3-spain",
    d: "M-1-0.9L-1-0.9L-1-0.9L-1-0.9L-1-0.9L-1-0.9L-1-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_447",
    className: "st3-spain",
    d: "M-1-0.8C-1-0.8-1-0.9-1-0.8C-1-0.9-1-0.9-1-0.8C-1-0.9-1-0.8-1-0.8C-1-0.8-1-0.8-1-0.8 C-1-0.8-1-0.8-1-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_448",
    className: "st3-spain",
    d: "M-0.8-0.7C-0.8-0.7-0.8-0.7-0.8-0.7c0.1,0,0.1,0,0.1,0C-0.7-0.6-0.7-0.7-0.8-0.7 C-0.8-0.7-0.8-0.7-0.8-0.7C-0.8-0.7-0.8-0.7-0.8-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_449",
    className: "st3-spain",
    d: "M-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8L-0.9-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_450",
    className: "st3-spain",
    d: "M-0.8-0.7C-0.8-0.7-0.8-0.7-0.8-0.7C-0.8-0.7-0.8-0.7-0.8-0.7C-0.9-0.7-0.9-0.7-0.8-0.7 C-0.9-0.7-0.8-0.7-0.8-0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "inescutcheon",
    transform: "translate(3.206 3.57)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_135",
    className: "st2-spain",
    cx: 0.1,
    cy: 0.1,
    rx: 1.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_136",
    className: "st7-spain",
    cx: 0.1,
    cy: 0.1,
    rx: 1,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "fdl",
    transform: "translate(0.673 0.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_451",
    className: "st3-spain",
    d: "M-1.1-1.6c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.2c0-0.1-0.1-0.1-0.1-0.1 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1,0.1l0,0c0,0,0,0,0,0h-0.1v0.1 h0.1l-0.1,0.1l0.1,0l0.1,0.1L-1-0.6l0.1,0L-1-0.7h0.1v-0.1H-1c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.1h0c0,0,0.1,0,0.1,0.1l0-0.1 c0,0,0,0,0-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1c0-0.1,0-0.2,0.1-0.2C-1-1.4-1-1.5-1.1-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_452",
    className: "st3-spain",
    d: "M-1.3-0.7h0.4v-0.1L-1.3-0.7L-1.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    transform: "translate(1.672 0.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_453",
    className: "st3-spain",
    d: "M-1.1-1.6c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.2c0-0.1-0.1-0.1-0.1-0.1 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1,0.1l0,0c0,0,0,0,0,0h-0.1v0.1 h0.1l-0.1,0.1l0.1,0l0.1,0.1L-1-0.6l0.1,0L-1-0.7h0.1v-0.1H-1c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.1h0c0,0,0.1,0,0.1,0.1l0-0.1 c0,0,0,0,0-0.1c0-0.1-0.1-0.1-0.1-0.1C-1-1.2-1-1.1-1-1.1C-1-1.2-1-1.2-1-1.3C-1-1.4-1.1-1.5-1.1-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_454",
    className: "st3-spain",
    d: "M-1.3-0.7h0.4v-0.1L-1.3-0.7L-1.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    transform: "translate(1.172 1.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_455",
    className: "st3-spain",
    d: "M-1.1-1.6c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.2c0-0.1-0.1-0.1-0.1-0.1 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0.1C-1.3-1-1.3-1-1.3-1c0.1,0,0.1,0,0.1,0.1l0,0c0,0,0,0,0,0h-0.1v0.1 h0.1l-0.1,0.1l0.1,0l0.1,0.1L-1-0.7l0.1,0L-1-0.8h0.1v-0.1H-1c0,0,0,0,0,0C-1-1-1-1-0.9-1h0c0,0,0.1,0,0.1,0.1l0-0.1 c0,0,0,0,0-0.1c0-0.1-0.1-0.1-0.1-0.1C-1-1.2-1-1.2-1-1.1C-1-1.2-1-1.3-1-1.4C-1-1.5-1-1.6-1.1-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_456",
    className: "st3-spain",
    d: "M-1.3-0.8h0.4v-0.1L-1.3-0.8L-1.3-0.8z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSpain);
export default __webpack_public_path__ + "static/media/FlagSpain.3319e40eb1a65f7b34c7be1d653164f0.svg";
export { ForwardRef as ReactComponent };